import CustomRecaptcha from '~/js/components/form-controls/CustomRecaptcha';
import '~/js/modules/fend';

const $tabSelects = $('#js-tab-select');
const $tabs = $('[data-init="tabs"] a');
const $form = $('#js-sign-up-form');
const $optMeIn = $('#subscribe');

const selectHandler = (event, ui) => {
    const { index } = ui.item;

    window.location = $tabs[index].href;
};

$tabSelects.selectmenu({
    appendTo: $tabSelects.parent(),
    select: selectHandler
});

$optMeIn.on('change', () => {
    $optMeIn.val($optMeIn.is(':checked'));
});

ReactDOM.render(
    <CustomRecaptcha
        wrapperClassName="col-xs-12 col-sm-6 col-sm-offset-3"
    />,
    document.getElementById('google-recaptcha')
);
import GoFetch from '~/js/modules/fetch-wrapper';
const fetch = new GoFetch();

function customSubmit(element, event) {
    event.preventDefault();
    const form = $(element);
    const fields = {};

    if(this.checkForm()) {
        form.find('input, select').each(function construct() {
            fields[this.name] = $(this).val();
        });
        fetch.submitForm(form.attr('action'), fields, true)
        .then((response) => {
            if(response.status === 'success' && form.data('location')) {
                window.location = form.data('location');
            }
        });
    }
}

$form.fend({
    onsubmit: customSubmit,
    rules: {
        title: 'lettersOnly',
        firstName: 'lettersOnly',
        lastName: 'lettersOnly',
        email: 'email',
        country: 'lettersOnly'
    }
});
